import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-adjust.tsx
/**
* icon.16.adjust
*
* edit, knobs, settings, configure, config, admin
*
* Keywords: sliders, vertical, controls, settings, equalizer, parameters
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuNSAxM2EuNS41IDAgMCAwIC41LS41di0xcS0uMDAxLS4wMzMtLjAwNy0uMDY1YTEuOTk4IDEuOTk4IDAgMCAwIDAtMy44NzJRNiA3LjUzMyA2IDcuNXYtNGEuNS41IDAgMCAwLTEgMHY0cTAgLjAzMy4wMDYuMDYzYTIgMiAwIDAgMCAwIDMuODcyUTUgMTEuNDY4IDUgMTEuNXYxYS41LjUgMCAwIDAgLjUuNW01IDBhLjUuNSAwIDAgMCAuNS0uNXYtNHEtLjAwMS0uMDMzLS4wMDctLjA2M2ExLjk5OCAxLjk5OCAwIDAgMCAwLTMuODcyUTExIDQuNTMyIDExIDQuNXYtMWEuNS41IDAgMCAwLTEgMHYxcTAgLjAzMy4wMDYuMDY0YTEuOTk4IDEuOTk4IDAgMCAwIDAgMy44NzNRMTAgOC40NjcgMTAgOC41djRhLjUuNSAwIDAgMCAuNS41bTAtNS41YTEgMSAwIDEgMSAwLTIgMSAxIDAgMCAxIDAgMm0tNSAzYTEgMSAwIDEgMSAwLTIgMSAxIDAgMCAxIDAgMiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11812
*/
const Icon16Adjust = memo(function Icon16Adjust(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M5.5 13a.5.5 0 0 0 .5-.5v-1q-.001-.033-.007-.065a1.998 1.998 0 0 0 0-3.872Q6 7.533 6 7.5v-4a.5.5 0 0 0-1 0v4q0 .033.006.063a2 2 0 0 0 0 3.872Q5 11.468 5 11.5v1a.5.5 0 0 0 .5.5m5 0a.5.5 0 0 0 .5-.5v-4q-.001-.033-.007-.063a1.998 1.998 0 0 0 0-3.872Q11 4.532 11 4.5v-1a.5.5 0 0 0-1 0v1q0 .033.006.064a1.998 1.998 0 0 0 0 3.873Q10 8.467 10 8.5v4a.5.5 0 0 0 .5.5m0-5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-5 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
		})
	});
});
//#endregion
export { Icon16Adjust };

//# sourceMappingURL=icon-16-adjust.js.map